import { Link } from 'react-router-dom'

export function Brand() {
  return (
    <Link className="brand" to="/" aria-label="Dr. Fathima Finu, home">
      <span className="brand-mark" aria-hidden="true">
        <span>F</span>
        <i />
      </span>
      <span className="brand-copy">
        <strong>Dr. Fathima Finu</strong>
        <small>General Doctor</small>
      </span>
    </Link>
  )
}
